import * as actionTypes from "../actionTypes/actionTypes";

const initialState = {
    selectedModel: undefined,
    selectedModelName: "",
    selectedTab: 0,
    selectedClose: {
      id:"",
      isClosed:false
    },
    snackbar: {
      show: false,
      severity: '', // 'success' | 'info' | 'warning' | 'error'
      message: ''
    } 
};

export const miscReducer = (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.SELECTED_TAB:
      return {
        ...newState,
        selectedTab: action.payload,
      };

      case actionTypes.SET_CLOSE_MODEL:
      return {
        ...newState,
        selectedClose: action.payload,
      };

    case actionTypes.SELECTED_MODEL:
      return {
        ...newState,
        selectedModel : action.payload.id,
        selectedModelName: action.payload.name
    }; 

    case actionTypes.SET_SNACKBAR: 
    return {
      ...newState,
      snackbar: action.payload
    }

    case actionTypes.SELECTED_PAGE_DRAWING: 
    return {
      ...newState,
      selectedDrawing: action.payload
    }

    default:
      return { ...newState };
  }
};
